/* unplugin-vue-components disabled */import { render } from "./BlackSelect.vue?vue&type=template&id=21e6d848"
import script from "./BlackSelect.vue?vue&type=script&lang=js"
export * from "./BlackSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.8.3__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__